import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal as ModalAntd } from 'antd'

import { Button, Modal } from 'src/components/Ant'
import {
  resetSaveFullRequest,
  saveFullRequest
} from 'src/core/store/ducks/requests/actions'
import { Request } from 'src/types'
import { ApplicationState } from 'src/store'
import { resetAir } from 'src/core/store/ducks/air/actions'
import { resetHotels } from 'src/core/store/ducks/hotels/actions'
import { resetVehicles } from 'src/core/store/ducks/vehicles/actions'
import { useT } from 'src/core/hooks/use-translation'

import SearchCardForm from '../search-card/form'
import SearchResultCardList from '../search-result-card/list'

type Props = {
  // itemEdit?: RequestItinerary
  request: Request
  toggle(): void
  visible: boolean
  approvals?: boolean
}

function ModalForm({
  // itemEdit,
  request,
  toggle,
  visible,
  approvals
}: Props) {
  const dispatch = useDispatch()
  const { requests } = useSelector((state: ApplicationState) => ({
    requests: state.requests
  }))

  const [saving, setSaving] = useState<boolean>(false)
  const { t } = useT()

  useEffect(() => {
    if (requests.saveFullRequestLoading !== saving && approvals && visible) {
      setSaving(requests.saveFullRequestLoading)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requests.saveFullRequestLoading])

  useEffect(() => {
    if (visible) {
      dispatch(resetAir())
      dispatch(resetHotels())
      dispatch(resetVehicles())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible])

  return (
    <Modal
      // cancelButtonProps={{ disabled: saving }}
      closable={!saving}
      forceRender
      maskClosable={!saving}
      title="web.services.vehicle.form.title"
      onCancel={() => {
        toggle()
        dispatch(resetSaveFullRequest())
      }}
      visible={visible}
      width={820}
      footer={[
        <Button
          key="cancel"
          onClick={() => {
            toggle()
            dispatch(resetSaveFullRequest())
          }}
          size="default"
          title="common.actions.cancel"
          type="default"
        />
      ]}
    >
      <SearchCardForm request={request} />
      <SearchResultCardList
        closeOnPick={false}
        loading={requests.saveFullRequestLoading}
        request={request}
        onSubmit={values =>
          ModalAntd.confirm({
            cancelText: t('common.actions.cancel'),
            content: t('web.services.alert-send-to-approval'),
            okText: t('common.actions.yes'),
            title: t('common.are-you-sure'),
            onCancel() {},
            onOk() {
              dispatch(
                saveFullRequest({
                  ...request,
                  full_request_vehicle: [{ ...values }]
                })
              )
            }
          })
        }
        // request={request}
      />
    </Modal>
  )
}

export default ModalForm
